import { render, staticRenderFns } from "./detailSTitle.vue?vue&type=template&id=69054546&scoped=true&"
import script from "./detailSTitle.vue?vue&type=script&lang=js&"
export * from "./detailSTitle.vue?vue&type=script&lang=js&"
import style0 from "./detailSTitle.vue?vue&type=style&index=0&id=69054546&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69054546",
  null
  
)

export default component.exports